import { SPATIAL_CONSTANTS } from '../consts/spatial-constants';

/**
 * Helper function to check if coordinates represent unknown location
 */
export function isUnknownSpatialData(centroid: string): boolean {
	return centroid === SPATIAL_CONSTANTS.UNKNOWN_CENTROID;
}
